module.exports = __webpack_public_path__ + "img/callRegister.526becb0.svg";